type UndoIconProps = React.SVGProps<SVGSVGElement> & {
  direction?: "left" | "right";
};

const UndoIcon = ({ direction = "left", ...props }: UndoIconProps) => {
  return (
    <svg
      viewBox="0 0 12 11"
      fill="none"
      width="1em"
      height="1em"
      style={{
        transform: direction === "right" ? "scaleX(-1)" : undefined,
        ...props.style,
      }}
      {...props}
    >
      <path
        d="M4.25656 8.51154H9.31362L8.80087 9.27411C8.73255 9.37493 8.69297 9.49244 8.68637 9.61405C8.67978 9.73566 8.70643 9.85677 8.76345 9.96438C8.82047 10.072 8.90572 10.162 9.01004 10.2249C9.11437 10.2877 9.23383 10.321 9.35562 10.321H9.35693C9.46651 10.321 9.57468 10.2964 9.67343 10.2489C9.77219 10.2014 9.859 10.1323 9.92743 10.0467L11.5055 8.07404C11.5552 8.01197 11.5823 7.93482 11.5823 7.85529C11.5823 7.77577 11.5552 7.69862 11.5055 7.63654L9.92743 5.6643C9.859 5.57872 9.77219 5.50963 9.67343 5.46215C9.57468 5.41466 9.46651 5.39 9.35693 5.38998H9.35562C9.23383 5.39007 9.11437 5.42331 9.01004 5.48614C8.90572 5.54898 8.82047 5.63903 8.76345 5.74665C8.70643 5.85426 8.67978 5.97537 8.68637 6.09698C8.69297 6.21858 8.73255 6.3361 8.80087 6.43692L9.31318 7.19948L4.25612 7.19948C3.86957 7.19948 3.48681 7.12335 3.12969 6.97542C2.77257 6.8275 2.44808 6.61068 2.17475 6.33735C1.90142 6.06402 1.6846 5.73953 1.53668 5.38241C1.38875 5.02529 1.31262 4.64253 1.31262 4.25598C1.31262 3.86944 1.38875 3.48668 1.53668 3.12955C1.6846 2.77243 1.90142 2.44794 2.17475 2.17461C2.44808 1.90128 2.77257 1.68447 3.12969 1.53654C3.48681 1.38862 3.86957 1.31248 4.25612 1.31248L5.68762 1.31248C5.86167 1.31248 6.02859 1.24334 6.15166 1.12027C6.27473 0.9972 6.34387 0.830281 6.34387 0.656233C6.34387 0.482184 6.27473 0.315265 6.15166 0.192194C6.02859 0.0691233 5.86167 -1.71661e-05 5.68762 -1.71661e-05L4.25612 -1.71661e-05C3.12736 -1.71661e-05 2.04483 0.448381 1.24667 1.24654C0.448518 2.04469 0.000119209 3.12722 0.000119209 4.25598C0.000119209 5.38474 0.448518 6.46727 1.24667 7.26543C2.04483 8.06358 3.12736 8.51198 4.25612 8.51198"
        fill="currentColor"
      />
    </svg>
  );
};

export default UndoIcon;
